import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

// Tokens da marca vêm do css-root.css da raiz do repo — a fonte é única.
import '@marca/css-root.css';
import './estilos/tokens.css';
import './estilos/base.css';
import './estilos/app.css';

import { App } from './app';
import { ProvedorApp } from './estado';

const raiz = document.getElementById('raiz');
if (!raiz) throw new Error('Elemento #raiz não encontrado no index.html.');

createRoot(raiz).render(
  <StrictMode>
    <BrowserRouter>
      <ProvedorApp>
        <App />
      </ProvedorApp>
    </BrowserRouter>
  </StrictMode>,
);
